import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-white scroll-mt-[72px]">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于我们
          </h2>
        </div>

        <div className="bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/70">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-primary-500 mb-6">
            {aboutContent.title}
          </h3>

          <div className="flex flex-col gap-4">
            {aboutContent.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {aboutContent.stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-4 rounded-lg bg-white border border-background-200/70"
              >
                <p className="text-2xl md:text-3xl font-label font-bold text-primary-500">
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}